module.exports = new __parcel__URL__("gpw-yearly--cover.fa3c2a8e.jpg").toString();